import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import { INITIAL_I18N_CONTEXT } from './i18n.const';
import I18nContext from './i18n.context';
import translator from './translator';
const I18nProvider = t0 => {
    const $ = _c(3);
    const { children } = t0;
    const translate = _temp;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            ...INITIAL_I18N_CONTEXT,
            translate
        };
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const contextValue = t1;
    let t2;
    if ($[1] !== children) {
        t2 = <I18nContext value={contextValue}>{children}</I18nContext>;
        $[1] = children;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    return t2;
};
export default I18nProvider;
function _temp(key, t0) {
    const variables = t0 === undefined ? {} : t0;
    const tag = key.split(".")[0];
    return translator.trans(key, variables, tag, LOCALE);
}
